import { useCallback, useEffect, useState } from 'react';
import api from '@/lib/api';
import { ONBOARDING_STEPS } from './onboardingSteps';

// Hook UNICO para el estado de onboarding: GET /onboarding/status + calculo derivado
// (applicable/done/total/allDone/firstRun). Lo usa el modal guiado; el checklist puede
// migrar a el en el futuro. Nunca revienta: si el endpoint falla, raw = null y el consumidor
// no monta nada (mismo criterio que el checklist: if (!status) return null).
export function useOnboardingStatus(enabled = true) {
  const [raw, setRaw] = useState(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    try {
      const res = await api.get('/onboarding/status');
      setRaw(res?.data || null);
      return res?.data || null;
    } catch (e) {
      setRaw(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!enabled) { setLoading(false); return; }
    refetch();
  }, [enabled, refetch]);

  const steps = raw?.steps || null;
  const applicable = steps ? ONBOARDING_STEPS.filter((s) => steps[s.key] !== 'gated') : [];
  const done = steps ? applicable.filter((s) => steps[s.key] === 'ok').length : 0;
  const total = applicable.length;
  const allDone = typeof raw?.all_done === 'boolean' ? raw.all_done : (total > 0 && done === total);
  const firstRun = raw?.first_run !== false; // ausente => true (fallback seguro)

  return { raw, steps, applicable, done, total, allDone, firstRun, loading, refetch };
}
